import { getVendorConfig } from "../config/ewalletVendors";

/**
 * Check if a payment method requires additional customer data before inquiry.
 *
 * Used by SecondForm to decide whether to show phone modal before proceeding.
 */
export function getPreInquiryRequirements(methodCode) {
  const config = getVendorConfig(methodCode);
  if (!config) return { requiresPhone: false };
  return { requiresPhone: config.requiresPhone };
}

/**
 * Determine navigation target after a successful proceed-inquiry response.
 *
 * Used by SecondForm after API call succeeds.
 * Returns { route, state } for navigate().
 */
export function resolvePostInquiryNavigation(result, paymentData, customerData) {
  const methodCode = result.data?.paymentMethod?.code;
  const config = getVendorConfig(methodCode);

  if (config?.flowType === "push_to_pay" && result.data?.ovo_push_initiated) {
    return {
      route: `/ovo-waiting/${result.data.paymentLinkHistory.reff_no}`,
      state: {
        orderId: result.data.paymentLinkHistory.reff_no,
        amount: paymentData.total_amount,
        result,
        customerPhone: customerData.phone,
      },
    };
  }

  return {
    route: `/instruction/${result.data.paymentLinkHistory.reff_no}`,
    state: {
      orderId: result.data.paymentLinkHistory.reff_no,
      amount: paymentData.total_amount,
      result,
    },
  };
}

/**
 * Determine how to handle ewallet instruction rendering in ThirdForm.
 *
 * For push-to-pay vendors: returns redirect info to waiting page.
 * For redirect vendors: returns null (render standard PaymentInstructionEwallet).
 */
export function resolveEwalletInstruction(result, ewalletData, orderId, amount) {
  const methodCode = result.data?.paymentMethod?.code;
  const config = getVendorConfig(methodCode);

  if (config?.flowType === "push_to_pay") {
    return {
      shouldRedirectToWaiting: true,
      route: `/ovo-waiting/${orderId}`,
      state: {
        orderId,
        amount,
        result,
        customerPhone: ewalletData?.customer_phone_masked || "",
      },
    };
  }

  return null;
}
